<template>

  <div v-if="isAuthenticated" class="telegram-auth text-center">
    <div class="auth-container align-items-center">

      <div class="d-flex">
        <img v-if="user && user.photo_url" :src="user.photo_url" :alt="user.first_name" class="rounded-circle" style="width: 40px; height: 40px; margin-right: 10px;">
        <h6 class="name w-100">{{ user && user.first_name }}</h6>
      </div>
      <button @click="logout" class="btn btn-sm btn-light nowrap logout">
        <i class="bi bi-box-arrow-right"></i> {{ $t('auth.logout') }}
      </button>
    </div>
  </div>
  <div v-else>
  <!-- telegram-login="bystrokurs_bot" -->
    <span v-if="!isLoaded">Loading...</span>
    <telegram-login-temp
      mode="callback"
      :telegram-login="configData.bot_username"
      @loaded="telegramLoadedCallbackFunc"
      @callback="authCallbackFunction"
      v-if="configData.bot_username"
    />

    <!-- Email login (Telegram→Web migration) -->
    <div v-if="showEmailLogin" class="email-login-section">
      <div class="divider-text">
        <span>{{ $t('auth.or') }}</span>
      </div>
      <email-login-form />
    </div>
  </div>

</template>

<script>
import { telegramLoginTemp } from 'vue3-telegram-login';
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { mapGetters } from 'vuex';
import EmailLoginForm from './EmailLoginForm.vue';

export default {
  components: {
    telegramLoginTemp,
    EmailLoginForm,
  },
  computed: {
    ...mapGetters('app', ['isMobile']),
  },
  setup() {
    const isLoaded = ref(false);
    const store = useStore();
    const route = useRoute();

    // Get configData from store (reactive)
    const configData = computed(() => store.getters['app/configData'] || {});

    const telegramLoadedCallbackFunc = () => {
      console.log('Script is loaded');
      isLoaded.value = true;
      authCallbackFunction();
    };

    const authCallbackFunction = (user) => {
      // Only process if user data is valid (from actual Telegram login, not just script load)
      if (!user || !user.id) {
        console.log('TelegramAuth: no user data, skipping login');
        return;
      }

      console.log('TelegramAuth: user authenticated', user);
      saveUserDataLocally(user);
      store.dispatch('user/loginUser', user);      
      //saveUser
      //store.dispatch('user/checkUser'); // Используем действие checkUser для проверки данных пользователя
    };

    const saveUserDataLocally = (user) => {
      // Don't overwrite with undefined/null
      if (user && user.id) {
        localStorage.setItem('userData', JSON.stringify(user));
      }
    };

    const logout = () => {
      localStorage.removeItem('userData');
      localStorage.removeItem('authToken');
      store.dispatch('user/updateAuthentication', false);
      store.dispatch('user/updateUser', null);
    };

    onMounted(() => {
      //authCallbackFunction();
      console.log('check user!');
      store.dispatch('user/checkUser'); // Вызываем действие checkUser при загрузке компонента
    });

    const isAuthenticated = computed(() => store.getters['user/isAuthenticated']);
    const user = computed(() => store.getters['user/getUser']);

    // Show email login for all services (Telegram→Web migration)
    const showEmailLogin = computed(() => {
      const name = configData.value?.chatbot_name || '';
      // Hide for bots where email auth doesn't apply
      if (name === 'harikatha' || name === 'chaitanyaacademy') return false;
      // Hide when route already renders EmailLoginForm as main content
      const path = route.path;
      if (path === '/set-password' || path === '/reset-password') return false;
      return true;
    });

    return {
      isLoaded,
      isAuthenticated,
      user,
      configData,
      showEmailLogin,
      telegramLoadedCallbackFunc,
      authCallbackFunction,
      logout
    };
  }
};
</script>
<style>
.auth-container{
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.auth-container .d-flex {
  flex: 1;
  min-width: 0;
  align-items: center;
}

.auth-container .name{
  margin-bottom: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 600;
}

.auth-container .logout {
  flex-shrink: 0;
  white-space: nowrap;
}

.email-login-section {
  margin-top: 16px;
}

.divider-text {
  display: flex;
  align-items: center;
  margin: 12px 0;
  color: #999;
  font-size: 13px;
}

.divider-text::before,
.divider-text::after {
  content: '';
  flex: 1;
  height: 1px;
  background-color: #dee2e6;
}

.divider-text span {
  padding: 0 12px;
}

</style>
